import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import moment from "moment";
import NotFoundModel from "../NotFoundModel";
import { GoDownload, GoEye } from "react-icons/go";

const ElectricityBillTable = ({
    apiData,
    type,
    propName
}) => {
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const ActionBtns = (bill) => {
        return (
            <div className="flex gap-4 ">
                {bill.docs &&
                    <>
                        <button
                            className={`cursor-pointer text-sm ${'bg-white text-gray-600'}  flex items-center justify-center`}
                            onClick={() => handleDocumentDownload(bill.docs)}
                        >
                            <GoDownload size={16} />
                        </button>
                    </>
                }
            </div>
        );
    };

    useEffect(() => {
        if (apiData && Array.isArray(apiData)) {
            const tempData = [];

            if (type === 1) {
                apiData.forEach(floor => {
                    if (floor && floor.rooms && Array.isArray(floor.rooms)) {
                        floor.rooms.forEach(room => {
                            if (room && room.prevBill && Array.isArray(room.prevBill) && room.prevBill.length > 0) {
                                room.prevBill.forEach(bill => {
                                    if (bill && bill.startDate && bill.endDate) {
                                        tempData.push({
                                            flatFloor: getNameForPG(floor.name, room.roomNum),
                                            roomNum: room.roomNum || 'N/A',
                                            count: bill.tenantCount + ' tenant/s' || 0,
                                            period: getBillingPeriod(bill),
                                            // period: `${moment(bill.startDate).format("DD MMM YYYY")} - ${moment(bill.endDate).format("DD MMM YYYY")}`,
                                            amount: <Amount>{'₹' + (bill.amount || 0)}</Amount>,
                                            action: ActionBtns(bill),
                                            createdAt: bill.generateDate ? moment(bill.generateDate).format("DD, MMM YYYY") : 'N/A',
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            } else if (type === 2) {
                apiData.forEach(flat => {
                    if (flat && flat.prevBill && Array.isArray(flat.prevBill) && flat.prevBill.length > 0) {
                        flat.prevBill.forEach(bill => {
                            if (bill && bill.startDate && bill.endDate) {
                                tempData.push({
                                    flatFloor: getNameForFlat(flat.name || ''),
                                    // No roomNum for type 2
                                    count: bill.tenantCount + ' tenant/s' || 0,
                                    period: getBillingPeriod(bill),
                                    // period: `${moment(bill.startDate).format("DD MMM YYYY")} - ${moment(bill.endDate).format("DD MMM YYYY")}`,
                                    amount: <Amount>{'₹' + (bill.amount || 0)}</Amount>,
                                    action: ActionBtns(bill),
                                    createdAt: bill.generateDate ? moment(bill.generateDate).format("DD, MMM YYYY") : 'N/A',
                                });
                            }
                        });
                    }
                });
            }

            setData(tempData);
        } else {
            setData([]);
        }
    }, [apiData, type]);

    const getNameForFlat = (flatName) => {
        return (
            <UserImageWrapper>
                <div className="flex flex-col gap-1">
                    <span className="text-gray-600 text-sm font-medium">
                        {propName?.charAt(0).toUpperCase() + propName?.slice(1)}{" "}
                    </span>
                    <div className="flex gap-1">
                        <span className="text-gray-400 text-xs">{flatName}</span>
                    </div>
                </div>
            </UserImageWrapper>
        );
    };

    const getNameForPG = (floorName, roomNo) => {
        return (
            <UserImageWrapper>
                <div className="flex flex-col gap-1">
                    <span className="text-gray-600 text-sm font-medium">
                        {propName?.charAt(0).toUpperCase() + propName?.slice(1)}{" "}
                    </span>
                    <div className="flex gap-1">
                        <span className="text-gray-400 text-xs">{floorName + ", " + roomNo}</span>
                    </div>
                </div>
            </UserImageWrapper>
        );
    };

    const handleDocumentDownload = (url) => {
        if (!url) return;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const getBillingPeriod = (bill) => {

        return (
            <div className='flex flex-col gap-0'>
                <span className="text-gray-600 text-sm">
                    {moment(bill.startDate).format("DD, MMM YYYY")} - {moment(bill.endDate).format("DD, MMM YYYY")}
                </span>
                {/* {bill.docs && (
                    <button
                        onClick={() => handleDocumentDownload(bill.docs)}
                        className="text-blue-400 text-xs underline text-left"
                    >
                        View Bill
                    </button>
                )} */}
            </div>
        );
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        const baseColumns = [
            {
                Header: type === 1 ? "PROPERTY" : "PROPERTY",
                accessor: "flatFloor",
            },
            {
                Header: "Amount",
                accessor: "amount",
            },
            {
                Header: "Divided In",
                accessor: "count",
            },
            {
                Header: "Billing Period",
                accessor: "period",
            },
            {
                Header: "Date",
                accessor: "createdAt",
            },
            {
                Header: "",
                accessor: "action",
            },
        ];

        // if (type === 1) {
        //     baseColumns.splice(1, 0, {
        //         Header: "Room No.",
        //         accessor: "roomNum",
        //     });
        // }

        if (isMobileView) {
            return type === 1
                ? [
                    { Header: type === 1 ? "Floor" : "Flat", accessor: "flatFloor" },
                    { Header: "Room No.", accessor: "roomNum" },
                ]
                : [
                    { Header: "Flat", accessor: "flatFloor" },
                ];
        }

        return baseColumns;
    }, [isMobileView, type]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);
    const renderMobileDetails = (row) => {
        if (type === 1) {
            return (
                <ul className="flex flex-col gap-2">
                    <li className="flex gap-2">
                        <strong>Tenant Count:</strong> {row.original.count}
                    </li>
                    <li className="flex gap-2">
                        <strong>Billing Period:</strong> {row.original.period}
                    </li>
                    <li className="flex gap-2">
                        <strong>Amount:</strong> {row.original.amount}
                    </li>
                    <li className="flex gap-2">
                        <strong>Creation Date:</strong> {row.original.createdAt}
                    </li>
                </ul>
            );
        } else {
            return (
                <ul className="flex flex-col gap-2">
                    <li className="flex gap-2">
                        <strong>Tenant Count:</strong> {row.original.count}
                    </li>
                    <li className="flex gap-2">
                        <strong>Billing Period:</strong> {row.original.period}
                    </li>
                    <li className="flex gap-2">
                        <strong>Amount:</strong> {row.original.amount}
                    </li>
                    <li className="flex gap-2">
                        <strong>Creation Date:</strong> {row.original.createdAt}
                    </li>
                </ul>
            );
        }
    };

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(data?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(data?.length > 0).toString()}>
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {

                                                    if (type === 1) {
                                                        if (cellIndex === 0 || (cellIndex === 1 && window.innerWidth < 768)) {
                                                            toggleRow(rowIndex);
                                                        }
                                                    } else {
                                                        if (cellIndex === 0 || window.innerWidth < 768) {
                                                            toggleRow(rowIndex);
                                                        }
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            {renderMobileDetails(row)}
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {data?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
            {data.length === 0 && (
                <NotFoundModel msg={"No Electricity Bill Generated Yet."} />
            )}

        </>
    );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Amount = tw.p`text-gray-500 text-sm bg-neutral-100 px-3 py-1 rounded-md inline-flex`
const UserImageWrapper = tw.div` flex items-center gap-2`;

export default ElectricityBillTable;